import React from "react";

const PersonalListsFilter = ({
  favoritesOnly,
  setFavoritesOnly,
  notificationsOnly = false,
  setNotificationsOnly,
  reefWizardOnly = false,
  setReefWizardOnly,
  reefWizardTankFilter = null,
  setReefWizardTankFilter,
  reefWizardTanks = [],
  showNotifications = true,
  showReefWizard = true,
  favoritesPosthogId = "filter-favorites-only",
}) => (
  <div className="mb-3 bg-gray-50 p-3 rounded-lg shadow">
    <label className="block text-sm font-medium text-gray-700 mb-1">
      Personal Lists
    </label>
    <div className="flex flex-col gap-2">
      <label className="flex items-center gap-2 bg-white p-2 rounded-lg shadow flex-1 text-nowrap">
        <input
          type="checkbox"
          className="form-checkbox"
          checked={favoritesOnly}
          onChange={(event) => setFavoritesOnly(event.target.checked)}
          data-posthog={favoritesPosthogId}
        />
        Show Favorites Only
      </label>
      {showNotifications && setNotificationsOnly && (
        <label className="flex items-center gap-2 bg-white p-2 rounded-lg shadow flex-1 text-nowrap">
          <input
            type="checkbox"
            className="form-checkbox"
            checked={notificationsOnly}
            onChange={(event) => setNotificationsOnly(event.target.checked)}
            data-posthog="filter-notifications-only"
          />
          Show Notifications Only
        </label>
      )}
      {showReefWizard && setReefWizardOnly && (
        <>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Reef Wizard
          </label>
          <label className="flex items-center gap-2 bg-white p-2 rounded-lg shadow flex-1 text-nowrap">
            <input
              type="checkbox"
              className="form-checkbox"
              checked={reefWizardOnly}
              onChange={(event) => {
                setReefWizardOnly(event.target.checked);
                if (!event.target.checked) {
                  setReefWizardTankFilter?.(null);
                }
              }}
              data-posthog="filter-reef-wizard-only"
            />
            Recommendations Only
          </label>
          {reefWizardOnly && reefWizardTanks && reefWizardTanks.length > 0 && (
            <select
              className="w-full p-2 border border-gray-300 rounded bg-white"
              value={reefWizardTankFilter || ""}
              onChange={(event) =>
                setReefWizardTankFilter?.(event.target.value || null)
              }
              data-posthog="filter-reef-wizard-tank"
            >
              <option value="">All Tanks</option>
              {reefWizardTanks.map((tank) => (
                <option key={tank.id} value={tank.id}>
                  {tank.name}
                </option>
              ))}
            </select>
          )}
        </>
      )}
    </div>
  </div>
);

export default PersonalListsFilter;
